<template>
  <RouterView v-if="payee" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['payee']),
  },
  created() {
    this.$emit('page', 'payers');
  },
};
</script>
